module.exports = __webpack_public_path__ + "img/floor_f11_01.cfa4797c.png";